export const translations = {
  el: {
    nav: {
      home: "Αρχική",
      apartments: "Διαμερίσματα",
      amenities: "Παροχές",
      gallery: "Φωτογραφίες",
      location: "Τοποθεσία",
      booking: "Κράτηση",
      contact: "Επικοινωνία",
      bookNow: "Κάντε Κράτηση",
    },
    hero: {
      overline: "Νικήτη · Σιθωνία · Χαλκιδική",
      title: "Sithonia Holidays",
      subtitle: "Οικογενειακά διαμερίσματα στη Νικήτη Χαλκιδικής",
      tagline:
        "Ζήστε ήρεμες, ποιοτικές διακοπές δίπλα στη θάλασσα. Μοναδική θέα, ζεστή φιλοξενία, και η ομορφιά της Σιθωνίας σε κάθε σας βήμα.",
      bookNow: "Κάντε Κράτηση",
      viewApartments: "Δείτε τα Διαμερίσματα",
      contactUs: "Επικοινωνία",
    },
    apartments: {
      overline: "Τα Καταλύματά μας",
      title: "Δύο μοναδικοί χώροι, μία αληθινή Ελληνική φιλοξενία",
      capacity: "Επισκέπτες",
      bedrooms: "Υπνοδωμάτια",
      bathrooms: "Μπάνια",
      perNight: "/ διανυκτέρευση",
      bookThis: "Κάντε Κράτηση",
      viewDetails: "Λεπτομέρειες",
      bookOnAirbnb: "Airbnb",
      bookOnBooking: "Booking.com",
      viewOnMap: "Δείτε στον χάρτη",
      newBadge: "Νέο!",
    },
    amenities: {
      overline: "Παροχές",
      title: "Όλα όσα χρειάζεστε για ξέγνοιαστες διακοπές",
      items: {
        wifi: "Δωρεάν Wi-Fi",
        ac: "Κλιματισμός",
        kitchen: "Πλήρως εξοπλισμένη κουζίνα",
        tv: "Τηλεόραση",
        parking: "Δωρεάν Parking",
        family: "Οικογενειακό περιβάλλον",
        beach: "Κοντά σε παραλίες",
        clean: "Άψογη καθαριότητα",
        space: "Άνετοι χώροι",
      },
    },
    gallery: {
      overline: "Φωτογραφίες",
      title: "Μια ματιά στη φιλοξενία μας",
    },
    location: {
      overline: "Η Τοποθεσία",
      title: "Νικήτη, η καρδιά της Σιθωνίας",
      description:
        "Στη γραφική Νικήτη της Σιθωνίας θα βρείτε χρυσές παραλίες με κρυστάλλινα νερά, παραδοσιακές ταβέρνες με αυθεντικές γεύσεις, όμορφα καφέ στο λιμανάκι, και γραφικά καλντερίμια στο Παλιό Χωριό. Ιδανικός προορισμός για οικογενειακές διακοπές και ρομαντικές αποδράσεις.",
      explore: "Εξερευνήστε τη Σιθωνία",
      directions: "Οδηγίες στον Χάρτη",
    },
    booking: {
      overline: "Κρατήσεις",
      title: "Κλείστε τις διακοπές σας απευθείας",
      subtitle:
        "Άμεση επιβεβαίωση. Ασφαλείς πληρωμές με Stripe. Καλύτερη τιμή απευθείας από εμάς.",
      checkin: "Άφιξη",
      checkout: "Αναχώρηση",
      adults: "Ενήλικες",
      children: "Παιδιά",
      apartment: "Διαμέρισμα",
      selectApartment: "Επιλέξτε διαμέρισμα",
      checkPrice: "Υπολογισμός Τιμής",
      total: "Σύνολο",
      nights: "διανυκτερεύσεις",
      night: "διανυκτέρευση",
      legend: "Διαθεσιμότητα",
      legendAvailable: "Διαθέσιμο",
      legendBooked: "Κλεισμένο",
      legendSelected: "Επιλογή σας",
      pickDates: "Επιλέξτε ημερομηνίες",
      cleaning: "Καθαριότητα",
      tax: "Τέλος ανθεκτικότητας στην κλιματική κρίση",
      taxTooltip: "Κρατικό τέλος βάσει Ν. 5073/2023. €1,5–€10/διανυκτέρευση ανάλογα με το είδος καταλύματος. Αποδίδεται απευθείας στο Δημόσιο.",
      shortStaySurcharge: "Χρέωση σύντομης διαμονής (+20%)",
      shortStayNotice: "Διαμονή κάτω από 3 νύχτες — εφαρμόζεται χρέωση +20%",
      payNow: "Πληρωμή με Κάρτα",
      processing: "Επεξεργασία...",
      unavailable: "Μη διαθέσιμο για αυτές τις ημερομηνίες",
      orBookOn: "Ή κάντε κράτηση μέσω",
      contactDirect: "Απευθείας Επικοινωνία",
      fillGuest: "Στοιχεία επισκέπτη",
      fullName: "Ονοματεπώνυμο",
      email: "Email",
      phone: "Τηλέφωνο",
      messageOpt: "Μήνυμα (προαιρετικό)",
      step1: "Επιλογή",
      step2: "Στοιχεία",
      step3: "Πληρωμή",
      continueToGuest: "Συνέχεια",
      back: "Πίσω",
    },
    contact: {
      overline: "Επικοινωνία",
      title: "Επικοινωνήστε μαζί μας",
      subtitle:
        "Είμαστε εδώ για να σας βοηθήσουμε να σχεδιάσετε τις τέλειες διακοπές σας.",
      name: "Όνομα",
      email: "Email",
      phone: "Τηλέφωνο",
      checkin: "Άφιξη",
      checkout: "Αναχώρηση",
      guests: "Επισκέπτες",
      message: "Μήνυμα",
      send: "Αποστολή",
      sent: "Το μήνυμά σας εστάλη!",
      whatsapp: "WhatsApp",
      call: "Κλήση",
      emailUs: "Email",
    },
    footer: {
      rights: "Με επιφύλαξη παντός νομίμου δικαιώματος.",
      quickLinks: "Γρήγοροι Σύνδεσμοι",
      contact: "Επικοινωνία",
      bookOn: "Κάντε κράτηση σε",
      tagline: "Οικογενειακά διαμερίσματα στη Νικήτη Χαλκιδικής",
    },
    cookie: {
      text: "Χρησιμοποιούμε cookies για να βελτιώσουμε την εμπειρία σας. Συνεχίζοντας, αποδέχεστε τη χρήση τους.",
      accept: "Αποδοχή",
    },
  },
  en: {
    nav: {
      home: "Home",
      apartments: "Apartments",
      amenities: "Amenities",
      gallery: "Gallery",
      location: "Location",
      booking: "Book",
      contact: "Contact",
      bookNow: "Book Now",
    },
    hero: {
      overline: "Nikiti · Sithonia · Halkidiki",
      title: "Sithonia Holidays",
      subtitle: "Family Apartments in Nikiti, Halkidiki",
      tagline:
        "Experience quiet, premium-quality holidays by the sea. Unique views, warm hospitality, and all the beauty of Sithonia at your fingertips.",
      bookNow: "Book Now",
      viewApartments: "View Apartments",
      contactUs: "Contact Us",
    },
    apartments: {
      overline: "Our Accommodations",
      title: "Two unique spaces, one authentic Greek hospitality",
      capacity: "Guests",
      bedrooms: "Bedrooms",
      bathrooms: "Bathrooms",
      perNight: "/ night",
      bookThis: "Book This",
      viewDetails: "View Details",
      bookOnAirbnb: "Airbnb",
      bookOnBooking: "Booking.com",
      viewOnMap: "View on map",
      newBadge: "New!",
    },
    amenities: {
      overline: "Amenities",
      title: "Everything you need for a carefree stay",
      items: {
        wifi: "Free Wi-Fi",
        ac: "Air Conditioning",
        kitchen: "Fully Equipped Kitchen",
        tv: "TV",
        parking: "Free Parking",
        family: "Family-friendly",
        beach: "Close to beaches",
        clean: "Impeccable cleanliness",
        space: "Spacious areas",
      },
    },
    gallery: {
      overline: "Gallery",
      title: "A glimpse into our hospitality",
    },
    location: {
      overline: "The Location",
      title: "Nikiti, the heart of Sithonia",
      description:
        "In picturesque Nikiti in Sithonia you will find golden beaches with crystal-clear waters, traditional taverns serving authentic flavours, lovely cafés by the small harbour, and charming cobbled streets in the Old Village. An ideal destination for family holidays and romantic getaways.",
      explore: "Explore Sithonia",
      directions: "Open in Maps",
    },
    booking: {
      overline: "Reservations",
      title: "Book your stay directly",
      subtitle:
        "Instant confirmation. Secure payments with Stripe. The best rates straight from us.",
      checkin: "Check-in",
      checkout: "Check-out",
      adults: "Adults",
      children: "Children",
      apartment: "Apartment",
      selectApartment: "Select apartment",
      checkPrice: "Calculate Price",
      total: "Total",
      nights: "nights",
      night: "night",
      legend: "Availability",
      legendAvailable: "Available",
      legendBooked: "Booked",
      legendSelected: "Your selection",
      pickDates: "Pick your dates",
      cleaning: "Cleaning fee",
      tax: "Climate Resilience Fee",
      taxTooltip: "Greek state-mandated fee (Law 5073/2023). €1.5–€10/night depending on accommodation type. Paid directly to the State.",
      shortStaySurcharge: "Short-stay surcharge (+20%)",
      shortStayNotice: "Stays under 3 nights include a +20% surcharge",
      payNow: "Pay with Card",
      processing: "Processing...",
      unavailable: "Not available for these dates",
      orBookOn: "Or book on",
      contactDirect: "Contact Directly",
      fillGuest: "Guest information",
      fullName: "Full name",
      email: "Email",
      phone: "Phone",
      messageOpt: "Message (optional)",
      step1: "Select",
      step2: "Details",
      step3: "Payment",
      continueToGuest: "Continue",
      back: "Back",
    },
    contact: {
      overline: "Contact",
      title: "Get in touch",
      subtitle: "We're here to help you plan your perfect holiday.",
      name: "Name",
      email: "Email",
      phone: "Phone",
      checkin: "Check-in",
      checkout: "Check-out",
      guests: "Guests",
      message: "Message",
      send: "Send Message",
      sent: "Your message has been sent!",
      whatsapp: "WhatsApp",
      call: "Call",
      emailUs: "Email",
    },
    footer: {
      rights: "All rights reserved.",
      quickLinks: "Quick Links",
      contact: "Contact",
      bookOn: "Book on",
      tagline: "Family apartments in Nikiti, Halkidiki",
    },
    cookie: {
      text: "We use cookies to improve your experience. By continuing, you accept their use.",
      accept: "Accept",
    },
  },
};
